import PropTypes from "prop-types";
import React from "react";

function LanguageFlag(props) {
  const { languageCode } = props;

  // Functions
  const handleLanguageCode = () => {
    if (languageCode.toLowerCase() === "en") {
      return "gb";
    }

    return languageCode.toLowerCase();
  };

  // Render
  return (
    <img
      loading="lazy"
      width="24"
      srcSet={`https://flagcdn.com/h40/${handleLanguageCode()}.png 2x`}
      src={`https://flagcdn.com/h24/${handleLanguageCode()}.png`}
      alt={languageCode}
    />
  );
}

LanguageFlag.propTypes = {
  languageCode: PropTypes.string.isRequired,
};

export default LanguageFlag;
